export default function PageHero({ eyebrow, title, titleAccent, subtitle }) {
  return (
    <section className="relative pt-40 pb-20 grain overflow-hidden">
      <div className="absolute inset-0 bg-radial-spotlight" />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <span className="inline-block text-[0.7rem] uppercase tracking-[0.4em] text-[var(--gold)] mb-6">— {eyebrow}</span>
        <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-white leading-[1.05] max-w-4xl">
          {title} <span className="gold-text italic">{titleAccent}</span>
        </h1>
        {subtitle && <p className="text-[var(--text-secondary)] max-w-2xl mt-6 text-base lg:text-lg leading-relaxed">{subtitle}</p>}
        <div className="divider-gold mt-12 max-w-md" />
      </div>
    </section>
  );
}
